import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core'
import { MatCheckboxChange } from '@angular/material/checkbox'
import { MatOption } from '@angular/material/core'
import { normalizeString } from '@shared/utils/degts-utils'
import { FormFieldComponent } from '@widgets/form-field/form-field.component'
import { SelectFieldProvider } from '@widgets/select-field/select-field-provider'
import { Subscription } from 'rxjs'

@Component({
  selector: 'bdg-multi-select-field',
  templateUrl: './multi-select-field.component.html',
  styleUrls: ['./multi-select-field.component.scss'],
})
export class MultiSelectFieldComponent<T extends { id: number | string }>
  extends FormFieldComponent
  implements OnInit, OnChanges, OnDestroy {
  @Input()
  provider: SelectFieldProvider<T>
  @Input()
  placeholder = 'Buscar...'
  @Input()
  labelCount = 3 // TODO usar esse input
  @Input()
  disableSelection = false

  @Input() set disable(value: boolean) {
    if (value) {
      this.control.disable()
    } else {
      this.control.enable()
    }
  }

  @ViewChild('searchInput') searchInput: ElementRef
  @ViewChild('checkAll') checkAllInput: ElementRef

  filteredOptions: Array<T> = []
  selectedValues: Array<T> = []

  private valueChangesSubscription: Subscription

  constructor() {
    super()
  }

  ngOnInit(): void {
    this.init()
  }

  ngOnDestroy(): void {
    this.unsubscribeToValueChanges()
  }

  ngOnChanges(changes: SimpleChanges): void {
    const controlChanged = changes?.control
    if (controlChanged && controlChanged.previousValue !== controlChanged.currentValue) {
      this.init()
    }
  }

  private init() {
    if (!this.control.value) {
      this.control.setValue([], { emitEvent: false })
    }
    this.filteredOptions = this.provider.options
    this.selectedValues = this.control.value
    this.subscribeToValueChanges()
  }

  private subscribeToValueChanges() {
    this.unsubscribeToValueChanges()
    this.valueChangesSubscription = this.control.valueChanges.subscribe((_) => {
      if (!this.control.dirty) {
        this.selectedValues = this.control.value || []
      }
    })
  }

  private unsubscribeToValueChanges() {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe()
    }
  }

  error() {
    return this.control && this.control.touched && this.control.errors?.error
  }

  openedChange(opened: boolean) {
    if (!opened) {
      this.filteredOptions = this.provider.options
      this.searchInput.nativeElement.value = ''
    }

    this.calculateAllChecked()
  }

  toggleSelectAll(source: MatCheckboxChange) {
    if (source.checked) {
      this.filteredOptions.forEach((option) => {
        if (!this.selectedValues.some((selected) => selected.id === option.id)) {
          this.selectedValues.push(option)
        }
        this.selectedValues = [...this.selectedValues]
      })
    } else {
      this.selectedValues = this.selectedValues.filter(
        (item) => !this.filteredOptions.some((filtered) => item.id === filtered.id)
      )
    }

    this.control.setValue(this.selectedValues, { emitEvent: false })
  }

  filterItem(filter: string) {
    this.filteredOptions = this.provider.options.filter((option) =>
      normalizeString(this.provider.description(option)).includes(normalizeString(filter))
    )
    this.calculateAllChecked()
  }

  onDisplayString() {
    if (this.selectedValues?.length > 0) {
      return (
        this.provider.description(this.selectedValues[0]) +
        (this.selectedValues.length === 1
          ? ''
          : ' + ' + (this.selectedValues.length - 1) + (this.selectedValues.length - 1 === 1 ? ' outro' : ' outros'))
      )
    }

    return this.placeholder
  }

  onSelectionChange(matOption: MatOption) {
    this.calculateAllChecked()
    this.rebuildControlValue(matOption)
  }

  private calculateAllChecked() {
    let count = 0
    this.control?.value?.forEach((item) => {
      if (this.filteredOptions.some((filtered) => item.id === filtered.id)) {
        count++
      }
    })
    this.checkAllInput[`checked`] = count > 0 && count === this.filteredOptions?.length
  }

  private rebuildControlValue(matOption: MatOption) {
    if (matOption.selected) {
      this.selectedValues.push(matOption.value)
    } else {
      this.selectedValues = this.selectedValues.filter((selected) => selected.id !== matOption.value.id)
    }

    this.control.setValue(this.selectedValues, { emitEvent: false })
  }
}
